<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>工资模块</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'punchStatistics' }"
              >打卡记录</el-breadcrumb-item
            >
            <el-breadcrumb-item>打卡详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="inputDiv">
      <div class="inputDiv">
        时间：
        <el-date-picker
          v-model="moment"
          type="month"
          placeholder="选择月"
          value-format="yyyy-MM"
          format="yyyy-MM"
        >
        </el-date-picker>
      </div>
      <div class="inputDiv">
        <div>
          姓名：<span>{{ name }}</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          电话：<span>{{ tel }}</span>
        </div>
      </div>
    </div>

    <div class="inputDiv">
      <div class="inputDiv">
        <div>
          正常上班：<span>{{ normalDays }}（天）</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          迟到/早退：<span>{{ abnormalDays }}（天）</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          未打卡：<span>{{ absenceDays }}（天）</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          本月天数：<span>{{ days }}（天）</span>
        </div>
      </div>
    </div>

    <div class="inputDiv">
      <el-button type="primary" class="widthButton" @click="search"
        >查询</el-button
      >
      <!-- <el-button type="primary" class="widthButton">新增</el-button> -->
      <!-- <el-button type="primary" class="widthButton">导出</el-button> -->
    </div>

    <el-table :data="tableData" border style="width: 95%">
      <el-table-column prop="dates" label="时间"> </el-table-column>
      <el-table-column prop="amInTime" label="上午上班"> </el-table-column>
      <el-table-column prop="amOffTime" label="上午下班"> </el-table-column>
      <el-table-column prop="amState" label="状态"> </el-table-column>
      <el-table-column prop="pmInTime" label="下午上班"> </el-table-column>
      <el-table-column prop="pmOffTime" label="下午下班"> </el-table-column>
      <el-table-column prop="pmState" label="状态"> </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :page-count="pageTotal"
    ></el-pagination>
  </div>
</template>
<script>
import { clockinSta, clockinSel } from "@/api/clockin";
import { getLast } from "@/util/time";
import moment from "moment";
export default {
  data() {
    return {
      value: "",
      id: "",
      name: "",
      tel: "",
      normalDays: 0,
      abnormalDays: 0,
      absenceDays: 0,
      days: 0,
      moment: moment(new Date()).format("YYYY-MM"),
      tableData: [],
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0
    };
  },
  mounted() {
    this.name = this.$route.query.staffName;
    this.id = this.$route.query.userId;
    this.moment = this.$route.query.month;
    this.tel = this.$route.query.tel;
    this.getClockinSta();
  },
  methods: {
    search() {
      this.handleCurrentChange(1);
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.getClockinSta();
    },
    getClockinSta() {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        staffName: this.name,
        tel: this.tel,
        month: this.moment
      };
      clockinSta(params)
        .then(res => {
          var date = res.gridData[0];
          if (date) {
            this.normalDays = date.normalDays;
            this.abnormalDays = date.abnormalDays;
            this.absenceDays = date.absenceDays;
            this.days = date.days;
          } else {
            const time = new Date(this.moment);
            const days = new Date(
              time.getFullYear(),
              time.getMonth() + 1,
              0
            ).getDate();
            this.normalDays = 0;
            this.abnormalDays = 0;
            this.absenceDays = 0;
            this.days = days;
          }
          this.getClockinSel();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getClockinSel() {
      var time = getLast(new Date(this.moment));
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        userId: this.id,
        beginTime: moment(new Date(time[0])).format("YYYY-MM-DD"),
        endTime: moment(new Date(time[1])).format("YYYY-MM-DD"),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      clockinSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          var tableData = [];
          res.gridData.forEach(element => {
            element.amInTime = element.amInTime ? element.amInTime : "未打卡";
            element.amOffTime = element.amOffTime
              ? element.amOffTime
              : "未打卡";
            element.pmInTime = element.pmInTime ? element.pmInTime : "未打卡";
            element.pmOffTime = element.pmOffTime
              ? element.pmOffTime
              : "未打卡";
            element.amState = element.amState == 0 ? "异常" : "正常";
            element.pmState = element.pmState == 0 ? "异常" : "正常";
            tableData.push(element);
          });
          this.tableData = tableData;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
